import React, { useEffect } from 'react';
import { Button } from '@/components/common/Button/Button';
import { useCookieConsent } from '@/context/CookieConsentContext';
import { initializeThirdPartyScripts, initializeIntercom } from '@/utils/scriptLoader';

const CookieConsent: React.FC = () => {
  const {
    isModalVisible,
    hideModal,
    hasAcceptedCookies,
    acceptCookies,
    rejectCookies
  } = useCookieConsent();

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    const consentMode = localStorage.getItem('framerCookiesConsentMode');

    // Always load Intercom regardless of cookie consent
    initializeIntercom();

    // Auto-show modal for new visitors, but don't override manual visibility
    if (!cookieConsent && !consentMode && !isModalVisible) {
      // Show on first visit only
      setTimeout(() => {
        const event = new CustomEvent('showCookieModal');
        document.dispatchEvent(event);
      }, 1000);
    }

    // Load other scripts if cookies were previously accepted
    if (cookieConsent === 'accepted') {
      initializeThirdPartyScripts();
    }
  }, [isModalVisible]);

  // Load third-party scripts when consent changes
  useEffect(() => {
    if (hasAcceptedCookies) {
      initializeThirdPartyScripts();
    }
  }, [hasAcceptedCookies]);

  const handleAccept = () => {
    acceptCookies();
    hideModal();
  };

  const handleReject = () => {
    rejectCookies();
    hideModal();
  };

  if (!isModalVisible) return null;

  return (
    <div
      id="cookie-popup"
      className="fixed bottom-6 left-6 bg-white shadow-lg rounded-xl p-6 z-50 max-w-sm"
      style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}
    >
      <h3 className="font-semibold text-gray-900 mb-3">Cookie Settings</h3>
      <p className="text-sm text-gray-600 mb-5">
        By clicking "Accept Cookies", you agree to the storing of necessary cookies on your device to enhance site navigation and disclose information in accordance with our <a href="/privacy-policy" className="text-gray-400 hover:text-gray-500" target="_blank" rel="noopener noreferrer">Cookie Policy</a>.
      </p>
      <div className="grid grid-cols-2 gap-3">
        <Button
          variant="gradient"
          color="primary"
          id="reject-cookies"
          onClick={handleReject}
          className="text-sm font-medium text-center whitespace-nowrap"
        >
          Reject Cookies
        </Button>
        <Button
          variant="solid"
          color="primary"
          id="accept-cookies"
          onClick={handleAccept}
          className="text-sm font-medium text-center whitespace-nowrap"
        >
          Accept Cookies
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;